import { useContext, useMemo } from 'react';
import { CalendarContext } from '../../contexts';

/**
 * This hook will return the locale's first day of the week in the getDay() format
 * new Date().getDay() returns 0-6 being Sunday-Monday
 * weekInfo.firstDay returns 1-7 being Monday-Sunday
 * */
export const useLocaleFirstDayOfWeekIndex = () => {
    const { locale } = useContext(CalendarContext);

    const firstDayOfWeek = useMemo(() => {
        try {
            // @ts-expect-error Not implemented in every browser and untyped
            return new Intl.Locale(locale).weekInfo.firstDay
                ? // @ts-expect-error Not implemented in every browser and untyped
                  new Intl.Locale(locale).weekInfo.firstDay % 7
                : 1;
        } catch (e) {
            return 1;
        }
    }, [locale]);

    return firstDayOfWeek;
};
